import {h} from 'preact';

export default function ErrorMessage({text}) {
	return (
		<div data-testid="error-msg">
			<p class="c-inputgroup__validation-text c-inputgroup__validation-text--errored">
				<svg  aria-hidden="true" width="16" height="16" class="c-inputgroup__validation-icon c-inputgroup__validation-icon--errored">
					<use href="/static/img/svg-sprite.svg#icon-error" />
				</svg>
				<span>{text}</span>
			</p>
		</div>
	);
}
